import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login/Login';
import AdminPanel from './components/AdminPanel/AdminPanel';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin-panel" element={<AdminPanel />} />
      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default App;